// extracted by mini-css-extract-plugin
export default {"customReason":"CERrrqWRa9l4gCJoy8Pk"};